import { createContext, useContext, useState, useCallback } from "react";
import WaitlistModal from "../components/WaitlistModal";

const WaitlistContext = createContext(null);

export const useWaitlist = () => useContext(WaitlistContext);

export function WaitlistProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [persona, setPersona] = useState("individual");

  const openWaitlist = useCallback((p = "individual") => {
    setPersona(p);
    setOpen(true);
  }, []);

  return (
    <WaitlistContext.Provider value={{ openWaitlist }}>
      {children}
      <WaitlistModal
        open={open}
        onClose={() => setOpen(false)}
        defaultPersona={persona}
      />
    </WaitlistContext.Provider>
  );
}
